/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiGroomingSearchRetrieveGroomingType =
  (typeof ApiGroomingSearchRetrieveGroomingType)[keyof typeof ApiGroomingSearchRetrieveGroomingType];

export const ApiGroomingSearchRetrieveGroomingType = {
  bath_and_brush: 'bath_and_brush',
  full_groom: 'full_groom',
} as const;
